import { PropsWithChildren } from 'react';
import classes from './LegacyAnchor.module.css';

type LegacyAnchorPropsType = PropsWithChildren<{
  href: string;
  className?: string;
}>;

export const LegacyAnchor: React.FC<LegacyAnchorPropsType> = ({
  href,
  children,
  className,
  ...props
}) => {
  return (
    <a
      className={`${classes.anchorRoot} ${className || ''}`}
      href={`${process.env.PUBLIC_DREAMHAUS_URL}${href}`}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {children}
    </a>
  );
};
